module.exports = __webpack_public_path__ + "static/media/Pig-Dice.efb8ac32.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/video/Pig-Dice.mp4
// module id = 69
// module chunks = 0